export default __webpack_public_path__ + "static/media/chevron-up-black.24e54b4f.svg";